
import React from 'react';
import { defineCommand } from '../../../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../../../concepts/commands/CommandDispatcher';
import { Button, Colors } from '../../../../../ui';
import { Badge } from '../../../../../ui/Badge';
import { useResolve } from '../../../../Container';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { jiraCreateIssue } from '../../../atlassian/AtlassianCommands';
import { AssitantToolSupport } from '../../AssistantToolSupport';
import { ToolCallPart } from '../../ChatTypes';

const DraftJiraIssueToolCallView = React.memo(({ args }: ToolCallPart) => {

    const dispatch = useResolve(CommandDispatcher);
    const onSave = () => {
        dispatch(jiraCreateIssue, [issueType, title, body]);
    };

    const { issueType, title, body } = args;

    return <Flexer padding=".5">
        <Flexer flex="row" align="center" gap=".5">
            <Badge color={Colors.positive}>New {issueType}</Badge>
            <Copy flush>
                <b>{title}</b>
            </Copy>
        </Flexer>
        <Flexer height=".5" />
        <Copy style={{ whiteSpace: 'pre-wrap' }}>{body}</Copy>
        <Flexer height=".5" />
        <Button onAction={onSave}>
            Save to Jira
        </Button>
    </Flexer>;
});

export const DraftJiraIssueToolSupport = AssitantToolSupport({
    toolName: 'draftJiraIssue',
    ui: DraftJiraIssueToolCallView,
    command: defineCommand(
        'assitantDraftJiraIssue',
        null,
        (cc, [args]: [any]) => {
            return true;
        }
    )
});
